import * as React from "react";

import T01 from "@stadium/shared/src/components/plasmic/T01";
import T001 from "@stadium/shared/src/components/plasmic/T001";
import T02 from "components/plasmic/T02";

import {
  TestimonialVariant,
  T_01,
  T_001,
  T_02,
} from "@stadium/shared/src/helpers/plasmic/static-slices";

export interface TestimonialProps {
  variant?: TestimonialVariant;
  testimonialData?: any;
  className?: string;
}

const Testimonial: React.FC<Readonly<TestimonialProps>> = (props) => {
  const { variant = T_02, className, testimonialData } = props;

  switch (variant) {
    case T_01:
      return <T01 className={className} testimonialData={testimonialData} />;
    case T_001:
      return <T001 className={className} testimonialData={testimonialData} />;
    case T_02:
      return <T02 className={className} testimonialData={testimonialData} />;
    default:
      return null;
  }
};

export default Testimonial;
